import Home from '../../Home';
import Programmes from '../../Programmes';

export const routes = [
  {path: '/', component: Home, exact: true, public: true},
  {path: '/programmes', component: Programmes, exact: true, public: true}
];
